import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'react-emotion'
import { mediumMediaQuery } from 'utils/style-helpers'
import { BackgroundContainer, BackgroundImage } from 'components/Background'
import Wrapper from 'components/Wrapper'

const Container = styled.div`
  min-height: 400px;
  padding: 260px 0 40px;
  position: relative;
  overflow: hidden;
`

const Image = styled(BackgroundImage)`
  &:after {
    background: rgba(56, 142, 60, 0.7);
    bottom: 0;
    content: "";
    display: block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`

const Title = styled.h1`
  color: #fff;
  font-size: 42px;
  margin: 0;
  text-align: center;
  text-transform: uppercase;

  ${mediumMediaQuery} {
    font-size: 55px;
  }
`

const Content = styled.div`
  position: relative;
`

const Hero = ({ heroImage, title, children }) => (
  <Container>
    <BackgroundContainer>
      <Image sizes={heroImage.sizes} />
    </BackgroundContainer>
    <Content>
      <Wrapper>
        {title && <Title>{title}</Title>}
        {children}
      </Wrapper>
    </Content>
  </Container>
)

Hero.propTypes = {
  heroImage: PropTypes.object.isRequired,
  title: PropTypes.string,
  children: PropTypes.object
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/Hero/index.js